import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

import { getCanUseApp } from '../../../../Resources/Organization/Apps/AppsData';
import RedirectTo from '../../../Common/RedirectTo';
import { SALES_PROPOSAL } from '../AppsData';

const SalaesProposalButton = () => {
  const canUseApp = useSelector(getCanUseApp(SALES_PROPOSAL));
  const dispatch = useDispatch();

  if (!canUseApp) {
    return (
      <Button
        fullWidth
        variant="contained"
        color="primary"
        style={{ color: '#ffffff', width: '100%' }}
        onClick={() => {
          Intercom('showNewMessage', "I'm interested in Sales Proposal Tool.");
        }}
      >
        Sign me up
      </Button>
    );
  }
  return (
    <Button variant="contained" color="primary" onClick={() => dispatch(RedirectTo.proposalsList())}>
      Manage proposals
    </Button>
  );
};

export default SalaesProposalButton;
